import { useDispatch, useSelector } from "react-redux"
import { State } from "../reducers"
import { REGEX_LETRAS_ESPACIOS } from "../constants/Regex"
import * as http from '../api/http'
import { ENDPOINTS } from "../api/config"
import { KEYS } from "../constants/keysStorage"
import { generalOpenModalError, generalOpenModalInfo, generalOpenModalMessage, generalOpenToastError, generalShowLoader, getFechaHora } from "./general.actions"
import { useEffect } from "react"

import FlechaDerechaIcon from '../media/felsv/white_right-arrow_icon.svg'
import EmitirIcon from '../media/felsv/white_check_icon.svg'
import MasOpcionesIcon from '../media/felsv/WhiteOpciones.svg'
import { unirChipsJoin, validarRegexLetras, validarRegexNumericoFloat2Decimales, validarRegexNumericoInt } from "../utils/strings.utils"
import { getMunicipios } from "./catalogos.actions"
import { facturacionGetUUID } from "./facturacion/facturacionEmision.actions"
import { convertDateFormatAnular, getFechaCA, getFechaFormato1 } from "../utils/stringDate"
import { anularFactura, anularFactura_DTE, descargarJson, generateQRImageFromBits, getExcelFactura, getFacturaImage, getFacturaPDF_New, getQR, sendTransactionEmail } from "./operaciones/operaciones.actions"
import { useHistory } from "react-router-dom"
import { OPSendEmail } from "../interfaces/operaciones.interface"
import { ActionND, NDProducto } from "../interfaces/nota-debito.interface"
import { NOTA_DEBITO_TYPES } from "../constants/nota-debito.types"
import { getTransactions } from "./historial/historialFilter.actions"
import { showMessageSucursalVacia } from "./userLogin.actions"
import { docsDatosReceptorReset, docsDatosReceptorSiguienteDispatch } from "./documentos/documentos.actions"
import useUtilsDocs from "./utils-documentos.actions"

export default function useNotaDebito (){
    const dteCode = "06";
    const {formCliente, formProducto, errorsCliente, errorsProducto, productos, productosOriginales, view, productoEdit, productoIndex, response_Emitir, clienteEncontrado} = useSelector((state: State) => state.notaDebito)
    const {departamentos, datosEmisor, unidadesMedida} = useSelector((state: State) => state.catalogos)
    const {DetallesDTE, TipoContribuyenteReceptor, idserviciodte, pagina} = useSelector((state: State) => state.historial.activeFactura)
    const {formFilter} = useSelector((state: State) => state.historial)
    const {datos} = useSelector((state: State) => state.userLogin)
    const datosReceptor = useSelector((state: State) => state.documentos.datosReceptor.form);

    const {datosUUID} = useSelector((state: State) => state.facturacion)
    const emisorGranContribuyente = datosEmisor?.tipoContribuyente === '1'
    const emisorJuridico = datosEmisor?.tipoEmpresa === '1'
    const receptorGranContribuyente = TipoContribuyenteReceptor === 'true'
    const dispatch = useDispatch()
    const history = useHistory()

    const {processFormCatalogoProducto, processOtrosImpuestosCalculo, procesOtrosImpuestosResumen} = useUtilsDocs();

    const cargarDatosIniciales = () => {
        let fechaActual = new Date().toISOString().split('T')[0]
        let sucursalConDocumento = formCliente?.datosSucursal?.find((suc: any) => suc.Documento.find((doc: any) => doc.iddocumento === '6'))
        let documentoSucursal = sucursalConDocumento?.Documento.find((doc: any) => doc.iddocumento === '6')

        dispatch(handleSetFormCliente({
            ...formCliente,
            fecha: fechaActual,
            sucursal: sucursalConDocumento?.idsucursal,
            serie: documentoSucursal?.idsucursaldocumento
        })) 

        const nombreDepartamento = departamentos.find(departamento => departamento.codigo === DetallesDTE.receptor.direccion.departamento)?.valor
        if (nombreDepartamento) {
            dispatch(getMunicipios(parseInt(DetallesDTE.receptor.direccion.departamento), nombreDepartamento, false))
        }
    }

    const cargarProductosIniciales = () => {
        if (productosOriginales?.length === 0) {
            const productosBase = DetallesDTE?.cuerpoDocumento.map((producto: any) => ({
                id: Math.floor(Math.random() * 900000) + 100000,
                cantidad: `${producto.cantidad}`,
                precio: `${producto.precioUni}`,
                descuento: `${producto.montoDescu}`,
                tipoDescuento: 'Monto',
                descripcion: producto.descripcion,
                conIva: false,
                servicio: producto.TipoProducto === "0",
                exento: producto.ventaExenta !== 0,
                original: true,
            }));
            dispatch(handleSetProductosOriginal(productosBase));
            dispatch(handleAddProducto([]));   
        }
    }

    const button_onBack = () => {
        dispatch(handleAddProducto([])); 
        dispatch(handleSetProductosOriginal([]));  
        dispatch(handleSetTotalOriginal(0));
    }

    const onChangeFormCliente = (field: string, value: any) => {
        if(!validateChange(field, value) && value.trim() !== '') return
        if (field === 'sucursal') {
            dispatch(handleSetFormCliente({...formCliente, 'serie': '', [field] : value}))
        } else {
            dispatch(handleSetFormCliente({...formCliente, [field] : value})) 
        }
        validateFormCliente(field, value)
    }

    const onChangeFormProducto = (field: string, value: any, extraData = {}) => {
        if(!validateChange(field, value) && value.trim() !== '') return
        dispatch(handleSetFormProducto({...formProducto, ...extraData, [field] : value}))
        validateFormProducto(field, value)
    }

    const onChangeSelectCatalogoProducto = (codeProduct: string) => {
        const newFormProducto = processFormCatalogoProducto(dteCode, formProducto, codeProduct)
        dispatch(handleSetFormProducto({...formProducto, ...newFormProducto}))
        validateFormProducto('descripcion', codeProduct);
    }
    
    const validateFormCliente = (field: string, value: string) => {
        let message = ''
        switch (field) {
            case 'sucursal':
                if (!value) {message = 'Sucursal es requerida';}
                break;

            case 'serie':
                if (!value) {message = 'Serie es requerida';}
                break;

            default:
                break;
        }

        dispatch(handleErrorsFormCliente({
            ...errorsCliente,
            [field] : message
        }))

        return (message)
    }

    const validateFormProducto = (field: string, value: string) => {
        let message = ''
        
        switch(field){
            case 'descripcion':
                if(value.trim() === ''){message = 'Descripción es obligatoria.'; break;}
                break;
            case 'cantidad':
                if(value.trim() === '' || parseFloat(value) === 0){message = 'La cantidad debe ser mayor a 0.'; break;}
                break;
            case 'precio':
                if(value.trim() === '' || parseFloat(value) < 0){message = 'El precio debe ser mayor a 0.'; break;}
                break;
            case 'descuento':
                let suma = parseFloat(formProducto.cantidad) * parseFloat(formProducto.precio)
                if(parseFloat(value) > 100 && formProducto.tipoDescuento === 'Porcentaje') {message = 'El porcentaje de descuento no puede ser mayor al 100%.'; break;}
                if(formProducto.tipoDescuento === 'Monto'){
                    if(parseFloat(value) > suma){message = 'El monto de descuento no puede ser mayor al precio.'; break;}
                }
                break;
        }
        dispatch(handleErrorsFormProducto({
            ...errorsProducto,
            [field] : message
        }))

        return (message)
    }

    const validateFormProductoEdit = (field: string, value: string) => {
        let message = ''
        
        switch(field){
            case 'descripcion':
                if(value.trim() === ''){message = 'Descripción es obligatoria.'; break;}
                break;
            case 'cantidad':
                if(value.trim() === '' || parseFloat(value) === 0){message = 'La cantidad debe ser mayor a 0.'; break;}
                break;
            case 'precio':
                if(value.trim() === '' || parseFloat(value) < 0){message = 'El precio debe ser mayor a 0.'; break;}
                break;
            case 'descuento':
                let suma = parseFloat(productoEdit.cantidad) * parseFloat(productoEdit.precio)
                if(parseFloat(value) > 100 && productoEdit.tipoDescuento === 'Porcentaje') {message = 'El porcentaje de descuento no puede ser mayor al 100%.'; break;}
                if(productoEdit.tipoDescuento === 'Monto'){
                    if(parseFloat(value) > suma){message = 'El monto de descuento no puede ser mayor al precio.'; break;}
                }
                break;
        }
        dispatch(handleErrorsFormProducto({
            ...errorsProducto,
            [field] : message
        }))

        return (message)
    }

    const validateChange = (field: string, value: string) => {
        switch(field){
            case 'nombre':
                return (REGEX_LETRAS_ESPACIOS.test(value))
            case 'descripcion':
                    return validarRegexLetras(value);
            case 'cantidad':
                    return validarRegexNumericoFloat2Decimales(value);
            case 'precio':
                    if(parseFloat(value) > 100000000000) return
                    return validarRegexNumericoFloat2Decimales(value);
            case 'descuento':
                    if(parseFloat(value) > 100000000000) return
                    return validarRegexNumericoFloat2Decimales(value);
            case 'noDocumento':
                    switch (formCliente.tipoDocumento){
                        case '36':
                            if(value.length > 14) return false
                            return(validarRegexNumericoInt(value))
                    }
                break;
            case 'nrc':
                return (!(value.length > 7))
            default:
                return true
        }
    }

    const cargarSucursales = async() => {
        const newFormCliente = { ...formCliente, datosSucursal: [], loadedSucursal: true };

        try {
            let message = 'No se logró obtener el catalogo de sucursales'
            const response: any = await api_getSucursales({
                idsucursal: `${datos.sucursal_seleccionada}`,
                tipodocumento: '06'
            })
            
            if (response.body && !response.message) {
                const sucursal = response.body;
                const hayDocs = sucursal[0]?.Documento?.length;
                
                if (hayDocs) {
                    newFormCliente.datosSucursal = sucursal;
                }
                dispatch(handleSetFormCliente(newFormCliente));
            } else {
                dispatch(generalOpenModalError(response.message || message))
            }
        } catch (error: any) {
            if(error?.response?.data?.errorCode === 1) { dispatch(handleSetFormCliente(newFormCliente)); return; }
            dispatch(generalOpenModalError(error?.response?.data?.message ?? 'Error al obtener las sucursales', error?.response?.data?.status))
        }
    }

    const button_onClickAgregarProducto = () => {
        let errors: { [key: string]: string } = {};

        Object.keys(formProducto).forEach((key) => {
            if (validateFormProducto(key, formProducto[key])){
                let propiedad = key
                let value = validateFormProducto(key, formProducto[key])
                errors[propiedad] = value
            }
        })
        dispatch(handleErrorsFormProducto({
            ...errorsProducto,
            ...errors
        }))

        if(Object.values(errors).some((err) => err !== '')){
            dispatch(generalOpenModalInfo('Revisa el formulario de producto'))
            return;
        }

        let tempArray = productos
        tempArray.push({...formProducto, id: Math.floor(Math.random() * 900000) + 100000})
        dispatch(handleAddProducto(tempArray))     
        dispatch(generalOpenModalInfo('Producto agregado correctamente.'))   
        dispatch(handleRestartFormProducto())
    }

    const button_onClickLimpiarFormProducto = () => {
        dispatch(handleRestartFormProducto())
        dispatch(handleErrorsFormProducto({
            ...errorsProducto,
            descripcion: '',
            cantidad: '',
            precio: '',
            descuento: ''
        }))
    }

    const footer_onClickNext = async() => {
        switch (view) {
            case 'Formularios':
                let errors: { [key: string]: string } = {};

                Object.keys(formCliente).forEach((key) => {
                    if (validateFormCliente(key, formCliente[key])){
                        let propiedad = key
                        let value = validateFormCliente(key, formCliente[key])
                        errors[propiedad] = value
                    }
                })
                dispatch(handleErrorsFormCliente({
                    ...errorsCliente,
                    ...errors
                }))

                if(Object.values(errors).some((err) => err !== '')){
                    dispatch(generalOpenModalInfo('Revisa los datos del formulario'))
                    return;
                }

                if(productos.length === 0){
                    dispatch(generalOpenModalInfo('Debes agregar al menos un producto para continuar.'))
                    return;
                }
                const datosRec:any = dispatch(docsDatosReceptorSiguienteDispatch())
                if(datosRec === true) return;

                if(calculosProductos().total >= 2147483647){
                    dispatch(generalOpenToastError('Las operaciones que intentas realizar estàn fuera del lìmite permitido'))
                    return;
                }

                try {
                    dispatch(generalShowLoader(true))
                    await Promise.all([
                        dispatch(facturacionGetUUID('06', false))
                    ])
                } finally {
                    dispatch(generalShowLoader(false))
                }
                dispatch(handleChangeView('Previsualizacion'))
                break;
            case 'Previsualizacion':
                dispatch(handleActiveModalEmitir(true))
                break;
            case 'Detalle':
                dispatch(handleActiveModalMasOpciones(true))
                break;
        }
    }

    const footer_onClickBack = () => {
        switch (view) {
            case 'Formularios':
                if(productos.length > 0) dispatch(handleActiveModalQuitarTodo(true))
                break;
            case 'Previsualizacion':
                dispatch(handleChangeView('Formularios'))
                break;
            case 'Detalle':
                dispatch(handleRestarFlujoDebito())
                dispatch(docsDatosReceptorReset())
                break;
        }
    }

    const footer_textButtons = () => {
        let textBack = ''
        let textNext = ''
        let iconBack = ''
        let iconNext = ''
        switch(view){
            case 'Formularios':
                textBack = 'Quitar todo'
                textNext = 'Siguiente'
                iconBack = ''
                iconNext = FlechaDerechaIcon
                break;
            case 'Previsualizacion':
                textBack = 'Anterior'
                textNext = 'Emitir'
                iconBack = ''
                iconNext = EmitirIcon
                break;
            case 'Detalle':
                textBack = ''
                textNext = 'Más opciones'
                iconBack = ''
                iconNext = MasOpcionesIcon
                break;
        }

        return {
            next: {
                text: textNext,
                icon: iconNext
            },
            back: {
                text: textBack,
                icon: iconBack
            }
        }
    }

    const button_onClickQuitarTodo = () => {
        dispatch(handleAddProducto([]))
        modal_cerrarQuitarTodo()
        dispatch(generalOpenModalInfo('Se eliminaron todos los productos de la lista'))
    }

    const actionButton_editar = (producto: NDProducto) => {
        let tempForm: { [key: string]: any } = {
            ...productoEdit,
            ...producto
        }

        let errors: { [key: string]: string } = {};

        Object.keys(tempForm).forEach((key) => {
            if (validateFormProducto(key, tempForm[key])){
                let propiedad = key
                let value = validateFormProducto(key, tempForm[key])
                errors[propiedad] = value
            }
        })
        dispatch(handleErrorsFormProducto({
            ...errors
        }))

        dispatch(handleSetIndexProductoEdit(producto.id))
        dispatch(handleActiveModalEditar(true))
        dispatch(handleSetProductoEdit(producto))
    }
    
    const modal_cerrarModalEditar = () => {
        button_onClickLimpiarFormProducto()
        dispatch(handleSetIndexProductoEdit(null))
        dispatch(handleActiveModalEditar(false))
        dispatch(handleSetProductoEdit({
            ...productoEdit,
            descripcion: '',
            cantidad: '',
            precio: '',
            descuento: ''
        }))
    }

    const actionButton_eliminarProducto = (index: any) => {
        dispatch(handleSetIndexProductoEdit(index))
        dispatch(handleActiveModalEliminar(true))
    }
    
    const modal_button_onConfirmEliminar = () => {
        dispatch(handleAddProducto(productos.filter((pro) => pro.id !== productoIndex)));
        dispatch(generalOpenModalInfo('Producto eliminado exitosamente.'))
        modal_cerrarModalEliminar()
    }
    
    const modal_cerrarModalEliminar = () => {
        dispatch(handleSetIndexProductoEdit(null))
        dispatch(handleActiveModalEliminar(false))
    }

    const modal_onChangeFormProductoEdit = (field: string, value: string) => {
        if(!validateChange(field, value) && value.trim() !== '') return

        dispatch(handleSetProductoEdit({
            ...productoEdit,
            [field] : value
        }))

        validateFormProductoEdit(field, value)
    }

    const modal_onChangeSelectCatalogoProductoEdit = (codeProduct: string) => {
        const newFormProductoEdit = processFormCatalogoProducto(dteCode, productoEdit, codeProduct)
        dispatch(handleSetProductoEdit({...productoEdit, ...newFormProductoEdit}))
    }

    const modal_button_onConfirmEdit = () => {
        let errors: { [key: string]: string } = {};

        Object.keys(productoEdit).forEach((key) => {
            if (validateFormProducto(key, productoEdit[key])){
                let propiedad = key
                let value = validateFormProductoEdit(key, productoEdit[key])
                errors[propiedad] = value
            }
        })
        dispatch(handleErrorsFormProducto({
            ...errorsProducto,
            ...errors
        }))

        if(Object.values(errors).some((err) => err !== '')){
            dispatch(generalOpenModalInfo('Revisa los datos del producto'))
            return;
        }

        dispatch(handleAddProducto(productos.map((pro) => (pro.id === productoIndex) ? {...productoEdit} : pro)))
        modal_cerrarModalEditar()
        dispatch(generalOpenModalInfo('Producto actualizado exitosamente.'))
    }

    const modal_cerrarQuitarTodo = () => {
        dispatch(handleActiveModalQuitarTodo(false))
    }

    const modal_cerrarEmitir = () => {
        dispatch(handleActiveModalEmitir(false))
    }

    const modal_button_emitirNuevo = async() => {
        dispatch(handleAddProducto([]))
        await dispatch(handleRestarFlujoDebito())
        dispatch(docsDatosReceptorReset())
        await dispatch(handleSetFormCliente(
            {
                fecha: '',
                tipoDocumento: '',
                noDocumento: '',
                nombre: '',
                departamento: '',
                municipio: '',
                direccion: '',
                email: '',
                telefono: '',
                actividad: '',
                actividadDescripcion: '',
                departamentoDescripcion: '',
                municipioDescripcion: '',
                nrc: '',
                
                datosSucursal: [],
                datosDocumento: [],
        
                sucursal: '',
                serie: '',
                loadedSucursal: false,
            }
        ))
        await dispatch(handleAddProducto([]))
        setTimeout(() => { 
            history.push('/history-invoice?reload=0')
            dispatch(handleChangeView('Formularios'))
        }, 2)
        dispatch(handleAddProducto([]))
    }

    const buscarCliente = async() => {
        if(formCliente.tipoDocumento && formCliente.noDocumento && (validateFormCliente('noDocumento', formCliente.noDocumento) === '')){
            // dispatch(generalShowLoader(true))
            try {
            } catch (err: any) {
                dispatch(generalOpenToastError(err?.response?.data?.message || 'Se produjo un error al buscar la información del cliente.', "Alerta"))
            } finally {
                // dispatch(generalShowLoader(false))
            }
        }
    }

    const modal_button_verDetalle = () => {
        dispatch(handleChangeView('Detalle'))
        dispatch(handleActiveModalEmitido(false))
        modal_cerrarEmitir()
    }

    const modal_cerrarMasOpciones = () => {
        dispatch(handleActiveModalMasOpciones(false))
        dispatch(handleActiveModalEmitido(false))
    }

    const modal_button_cerrarModalEmitido = () => {
        dispatch(handleRestarFlujoDebito())
        dispatch(docsDatosReceptorReset())
        dispatch(handleAddProducto([]))
        dispatch(handleActiveModalEmitido(false))
        history.push('/otros-documentos')
    }

    const modal_button_enviarCorreo = () => {
        dispatch(handleActiveModalCorreo(true))
    }

    const modal_button_cerrarEnviarCorreo = () => {
        dispatch(handleActiveModalCorreo(false))
    }

    const modal_button_descargarExcel = async() => {
        try {
            dispatch(generalShowLoader(true))
            await dispatch(getExcelFactura(
                {
                    Documento: response_Emitir.JsonFactura,
                    Sello: response_Emitir.Sello,
                },
                response_Emitir.codigoGeneracion
            ))
        } catch (error) {
            dispatch(generalOpenModalError('Ocurrió un error al descargar el Excel.'))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const modal_button_descargarImagen = async() => {
        try {
            dispatch(generalShowLoader(true))
            await dispatch(getFacturaImage(
                {
                    Documento: response_Emitir.JsonFactura,
                    Sello: response_Emitir.Sello,
                },
                response_Emitir.codigoGeneracion
            ))
        } catch (error) {
            dispatch(generalOpenModalError('Ocurrió un error al descargar la imagen.'))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const modal_button_descargarPDF = async() => {
        try {
            dispatch(generalShowLoader(true))
            await dispatch(getFacturaPDF_New(
                {
                    Documento: response_Emitir.JsonFactura,
                    Sello: response_Emitir.Sello,
                },
                response_Emitir.serie,
                response_Emitir.estadoanulacion
            ))
        } catch (error) {
            dispatch(generalOpenModalError('Ocurrió un error al descargar el PDF.'))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const modal_button_imprimir = () => {
        dispatch(handleActiveModalImprimir(true))
    }

    const modal_cerrarImprimir = () => {
        dispatch(handleActiveModalImprimir(false))
    }

    const modal_button_onClickEnviarCorreo = async(email: string) => {
        try {
            dispatch(generalShowLoader(true))
            const sendEmail: OPSendEmail = {
                Correo: email,
                Documento: response_Emitir.JsonFactura,
                Sello: response_Emitir.Sello,
                json: response_Emitir?.JsonFacturaFile || "",
                idSucursal: datos?.sucursal_seleccionada,
                idEmpresa: `${datos?.codigo_empresa}`
            }
            const res:any = await dispatch(sendTransactionEmail(sendEmail))
            if(res){
                dispatch(generalOpenModalMessage('Enviar por correo electrónico', 'El correo electrónico fue enviado exitosamente.'))
                return true;
            }
        } catch (error: any) {
            dispatch(generalOpenModalError(error?.response?.data?.message || 'Ocurrió un error al enviar el correo'))
            return false
        } finally {
            dispatch(generalShowLoader(false))
        }
    }
    
    const modal_button_descargarJson = () => dispatch(descargarJson({idFactura: response_Emitir?.codigoGeneracion, json: response_Emitir?.JsonFacturaFile})) 

    const modal_button_anular = () => {
        dispatch(handleActiveModalAnular(true))
    }

    const modal_cerrarAnular = () => {
        dispatch(handleActiveModalAnular(false))
    }

    const modal_cerrarClienteEncontrado = () => {
    }

    const modal_button_aceptarClienteEncontrado = async() => {
        let tempForm: { [key: string]: any } = {
            ...formCliente,
            nombre: clienteEncontrado.nombre,
            tipoDocumento: clienteEncontrado.tipoDocumento,
            noDocumento: clienteEncontrado.numDocumento,
            direccion: clienteEncontrado.direccion,
            email: clienteEncontrado.email,
            telefono: clienteEncontrado.telefono,
            nrc: clienteEncontrado.nrc,
            actividad: clienteEncontrado.codActividad,
            departamento: clienteEncontrado.departamento,
            municipio: clienteEncontrado.municipio
        }

        let errors: { [key: string]: string } = {};

        Object.keys(tempForm).forEach((key) => {
            if (validateFormCliente(key, tempForm[key])){
                let propiedad = key
                let value = validateFormCliente(key, tempForm[key])
                errors[propiedad] = value
            }
        })
        dispatch(handleErrorsFormCliente({
            ...errors
        }))        

        dispatch(handleSetFormCliente(tempForm))
        modal_cerrarClienteEncontrado()
    }

    const modal_button_onConfirmAnular = async() => {
        dispatch(generalShowLoader(true))

        try {
            //------------------------
            let documento = formCliente?.datosSucursal?.find((sucursal: any) => sucursal?.idsucursal === formCliente?.sucursal)?.Documento?.find((doc: any) => doc?.idsucursaldocumento === formCliente?.serie)
            let serie = `${documento?.serie}-${documento?.numeroactual}`
            let ivaTotal = 0
            productos.forEach((producto) => {
                let precioUnitario = producto.conIva ? parseFloat(producto.precio)/1.13 : parseFloat(producto.precio)
                let ivaProducto = (precioUnitario * 0.13) * parseFloat(producto.cantidad)
                if(!producto.exento){
                    ivaTotal += ivaProducto
                }
            })
            //------------------------
            const receptor = DetallesDTE.receptor;

            const anularDoc = {
              documento: response_Emitir.JsonFactura,
              sellorecibido: response_Emitir.Sello,
              DetallesDTE: {
                receptor: {
                  numDocumento: receptor.nit,
                  tipoDocumento: '36',
                  nrc: receptor.nrc,
                  nombre: receptor.nombre,
                  telefono: receptor.telefono,
                  correo: receptor.correo,
                },
                emisor: {
                  nombre: datosEmisor.nombre,
                  nit: datosEmisor.nit,
                  nrc: datosEmisor.nrc,
                  telefono: datosEmisor.telefono,
                  correo: datosEmisor.correo,
                  tipoEstablecimiento: datosEmisor.tipoestablecimiento,
                },
                resumen: {
                  totalIva: isNaN(ivaTotal) ? '0' : `${ivaTotal.toFixed(2)}`,
                },
                identificacion: {
                  tipoDte: '06',
                  codigoGeneracion: response_Emitir.codigoGeneracion,
                  numeroControl: `DTE-06-${serie}`,
                  fecEmi: convertDateFormatAnular(response_Emitir.fhProcesamiento.split(' ')[0]),
                  IDsucursalDoc: documento.idsucursaldocumento
                },
              },
            }
            const response: any = await dispatch(anularFactura_DTE(anularDoc))
            if(response){
                dispatch(generalOpenModalInfo('Documento anulado exitosamente'))
                dispatch(getTransactions(formFilter, pagina, true));
                modal_button_emitirNuevo()
            }
            

        } catch (error: any) {
            dispatch(generalOpenModalError(error?.response?.data?.body?.descripcionMsg || 'Ocurrió un error al anular el documento.'))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const modal_button_emitirDocumento = async() => {
        dispatch(generalShowLoader(true))
        const horasActuales:any = await dispatch(getFechaHora());
        try{
            // -----------------------------------------------------------------
            let descuentoTotal = 0
            productos.forEach((producto) => {
                let descuento = 
                    producto.tipoDescuento === 'Porcentaje' ? 
                        (parseFloat(producto.descuento || '0')/100 * (producto.conIva ? parseFloat(producto.precio)/1.13 : parseFloat(producto.precio))) * parseFloat(producto.cantidad) :
                        parseFloat(producto.descuento || '0')

                descuentoTotal += descuento
            })

            let documento = formCliente?.datosSucursal?.find((sucursal: any) => sucursal?.idsucursal === formCliente?.sucursal)?.Documento?.find((doc: any) => doc?.idsucursaldocumento === formCliente?.serie)
            let serie = `${documento?.serie}-${documento?.numeroactual}`
            
            const receptor = DetallesDTE.receptor;
            let body: any = {
                idserviciodte: idserviciodte,
                id_user: localStorage.getItem(KEYS.ID_CLIENT),
                facturas: 
                [{
                    receptorEmailsEnvio: receptor.correo,
                    receptorManual: datosReceptor.nombre,
                    docManual: datosReceptor.numId,
                    esReceptorManual : datosReceptor.esReceptorManual,
                    tipoDocManual : datosReceptor.nombreTipoDocumento,
                    idsucursaldocumento: formCliente.serie,
                    tipoDte: "06",
                    cveDoc: serie,
                    uuid: datosUUID?.CodigoGeneracion,
                    docAnt: DetallesDTE?.identificacion?.numeroControl,
                    fechaDoc: horasActuales ? (`${horasActuales.FechaDDMM} ${horasActuales.Hora}`) : `${getFechaFormato1()} ${new Date().toLocaleTimeString([], {hour: '2-digit', minute: '2-digit', second: '2-digit'})}`,
                    canTotal: `${calculosProductos().sumaOperaciones.toFixed(2)}`,
                    impuTotal: `${calculosProductos().iva.toFixed(2)}`,
                    impuTotal2: `${calculosProductos().ivaRetenido.toFixed(2)}`,
                    impuTotal3: `${calculosProductos().ivaPercibido.toFixed(2)}`,
                    descuentoTotal: `${descuentoTotal.toFixed(2)}`,
                    retencionRenta: `${calculosProductos().retencionRenta.toFixed(2)}`,
                    condicion: `${formCliente.condicion}`,
                    receptor: {
                        rfc: receptor.nit,
                        nit: receptor.nit,
                        nombre: receptor.nombre,
                        direccion: receptor.direccion.complemento,
                        email: receptor.correo,
                        telefono: receptor.telefono,
                        nrc: receptor.nrc,
                        codActividad: receptor.codActividad,
                        descAtvividad: receptor.descActividad,
                        departamento: receptor.direccion.departamento,
                        municipio: receptor.direccion.municipio,
                    },
                    docRelacionado: [
                        {
                            tipoDocumento: '03',
                            tipoDocRelDesc: 'Comprobante de crédito fiscal',
                            numeroDocumento: DetallesDTE?.identificacion?.codigoGeneracion,
                            DTERelacionado: DetallesDTE?.identificacion?.numeroControl,
                            fechaEmision: `${DetallesDTE?.identificacion?.fecEmi} ${DetallesDTE?.identificacion?.horEmi}`,
                            fechaDocRel: getFechaCA(DetallesDTE?.identificacion?.fecEmi),
                            tipoGeneracion: 2
                        },
                    ],
                    cuerpoDocumento: productos.map((producto) => {
                        let precioUni = producto.conIva ? parseFloat(producto.precio)/1.13 : parseFloat(producto.precio)
                        let impuestoItem = 0
                        let ivaPercibido = 0
                        let ivaRetenido = 0

                        let descuento = 
                            producto.tipoDescuento === 'Porcentaje' ? 
                                (parseFloat(producto.descuento || '0')/100 * (producto.conIva ? parseFloat(producto.precio)/1.13 : parseFloat(producto.precio))) * parseFloat(producto.cantidad) :
                                parseFloat(producto.descuento || '0') 
            
                        let precio = parseFloat(producto.precio) * parseFloat(producto.cantidad) - descuento
                        
                        if(!producto.exento && emisorJuridico){
                            impuestoItem += precio * 0.13

                            if(emisorGranContribuyente && emisorJuridico && !receptorGranContribuyente && precio >= 100){
                                ivaPercibido += precio*0.01
                            }

                            if(!emisorGranContribuyente && receptorGranContribuyente && precio >= 100){
                                ivaRetenido += precio*0.01
                            }
                        }

                        return ({
                            numeroDocumento: DetallesDTE?.identificacion?.codigoGeneracion,
                            cantidad: `${parseFloat(producto.cantidad).toFixed(2)}`,
                            precioUni: `${precioUni.toFixed(2)}`,
                            impuesoItem: `${impuestoItem.toFixed(2)}`,
                            impuesoItem2: `${ivaRetenido.toFixed(2)}`,
                            impuesoItem3: `${ivaPercibido.toFixed(2)}`,
                            impuesto: producto.exento ? '0' : "13",
                            impuesto2: producto.exento ? '0' : ivaPercibido > 0 ? '1' : '0',
                            impuesto3: producto.exento ? '0' : ivaPercibido > 0 ? '1' : '0',
                            descripcion: producto.descripcion,
                            descuento: isNaN(descuento) ? '0' : `${descuento.toFixed(2)}`,
                            TipoMonto: producto.exento ? '1' : '0',
                            TipoItem: producto.servicio ? '0' : '1',
                            unidad: producto?.unidadMedida,
                            descUnidad: unidadesMedida.find((unidad) => unidad.codigo === producto?.unidadMedida)?.valor,
                            tributos: producto.tributos ?? [],
                            codigo: producto.clave ?? '',
                        })
                    }),
                    tributos: calculosProductos().resumenTributos,
                }],
                tokenGateway: localStorage.getItem(KEYS.TOKEN) ?? '',
                tokenHacienda: localStorage.getItem(KEYS.HACIENDA) ?? '',
                idSucursal: datos?.sucursal_seleccionada,
                idEmpresa: `${datos?.codigo_empresa}`
            }

            const response: any = await api_RecepcionDTE(body)
            if(response.body.estado === 'PROCESADO'){
                if(response?.body?.NuevoToken){
                    localStorage.setItem(KEYS.HACIENDA, response?.body?.TokenHacienda)
                    }
                dispatch(getTransactions(formFilter, pagina, true));
                dispatch(handleSetResponseEmitir(response.body))
                dispatch(handleActiveModalEmitido(true))
                dispatch(handleActiveModalEmitir(false))
                dispatch(handleChangeView('Detalle'))
                const qrResponse = await getQR(response.body.JsonFactura)
                if(qrResponse.qr){
                    let qrString = generateQRImageFromBits(qrResponse.qr?.replace("data:image/jpeg;base64,", ""))
                    dispatch(handleSetQRCode(qrString))
                } else {
                    dispatch(generalOpenModalError(qrResponse.message || 'Ocurrió un error al obtener el código QR'))
                }
            }
        } catch (err: any) {
            let message = 'Ocurrió un error al emitir el crédito fiscal, contacta al administrador.'

            if(err.response?.data?.message) message = err.response.data.message
            else {
                try{
                    let messageDesc = err?.response?.data?.body?.descripcionMsg?.replace(/\[(\w+)\.(\w+)\]\s(\w+)/, '$2 de $1 : $3').toUpperCase()
                    message = messageDesc || message
                } catch {
                    message = 'Ocurrió un error al emitir el crédito fiscal, contacta al administrador.'
                }
            }

            dispatch(generalOpenModalError(message))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const mostrarObservacionesError = (arrayObservaciones: any, message: string): string => {
        if (Array.isArray(arrayObservaciones)) {
          const errorMessage = construirErrorMessage(arrayObservaciones);
          if (errorMessage) {
            message = errorMessage;
            if (contieneCampoReceptor(arrayObservaciones)) {
                dispatch(handleActiveModalEmitir(false))
                dispatch(handleChangeView('Formularios'))
            }
          }
        }
        return message;
      };

      const contieneCampoReceptor = (observaciones: string[]): boolean => {
        const cadena = 'Campo #/receptor';
        return observaciones.some((el: string) => el.trim().includes(cadena));
      };

      const construirErrorMessage = (observaciones: string[]): string => {
        let errorMessage = '';
        observaciones.forEach((el: string) => {
          if (formCliente.tipoDocumento === 'sinDocumento') {
            if (el.trim().includes('#/receptor/tipoDocumento')) {
              errorMessage += `<li>La cantidad a facturar no es permitida para la opción "Sin documento", debe seleccionar otro tipo de documento.</li>`;
            }
            if (el.trim().includes('#/receptor/numDocumento')) {
              errorMessage += `<li>La cantidad a facturar no es permitida para la opción "Sin documento", debe ingresar un número de documento.</li>`;
            }
          }  else if (el.trim().includes('Campo #/receptor/')) {
            el = el.replaceAll('Campo #/receptor/', 'Formulario con datos del cliente el campo: ');
            errorMessage += `<li>${el} o está vacío.</li>`;
          } else errorMessage += `<li>${el}.</li>`;
        });
        if (errorMessage)  errorMessage = `No se pudo generar el crédito fiscal, Hacienda solicita llenar los siguientes campos:<br><br><ol>${errorMessage}</ol>`;
        return errorMessage;
      };
      
    const calculosProductos = () => {
        let sumaOperaciones = 0
        let iva = 0
        let subtotal = 0
        let ivaPercibido = 0
        let ivaRetenido = 0
        let retencionRenta = 0
        let total = 0
        let otrosImpuestos = 0
        let resumenTributos:Array<any> = [];

        productos.forEach((producto) => {
            let descuento = 
            producto.tipoDescuento === 'Porcentaje' ? 
                (parseFloat(producto.descuento || '0')/100 * (producto.conIva ? parseFloat(producto.precio)/1.13 : parseFloat(producto.precio))) * parseFloat(producto.cantidad) :
                parseFloat(producto.descuento || '0') 
            
            let precioConIVA = ((parseFloat(producto.precio)/1.13)) * parseFloat(producto.cantidad) - descuento
            let precioSinIVA = (parseFloat(producto.precio)) * parseFloat(producto.cantidad) - descuento
            let precio = producto.conIva ? precioConIVA : precioSinIVA
            

            if(!producto.exento) iva += (precio * 0.13)

            if(!producto.exento && emisorJuridico){
                if(emisorGranContribuyente && emisorJuridico && !receptorGranContribuyente){
                    ivaPercibido += parseFloat((precio*0.01).toFixed(2))
                }
            }

            if(!producto.exento){
                if(!emisorGranContribuyente && formCliente.granContribuyente){
                    ivaRetenido += parseFloat((precio*0.01).toFixed(2))
                }
            }

            if(producto.servicio && !emisorGranContribuyente && !emisorJuridico){
                retencionRenta += parseFloat((precio*0.1).toFixed(2))
            }

            sumaOperaciones += precio

            otrosImpuestos += processOtrosImpuestosCalculo(dteCode, producto, precio, false);
            resumenTributos = procesOtrosImpuestosResumen(dteCode, resumenTributos, producto, precio);
        })

        resumenTributos.forEach((resum) => {
            resum.valor = parseFloat(resum.valor.toFixed(2));
        });
        
        if(sumaOperaciones < 100 && (ivaPercibido > 0 || ivaRetenido > 0)) {
            ivaRetenido = 0;
            ivaPercibido = 0;
        }
        
        iva = roundTo(iva, 2)
        sumaOperaciones = roundTo(sumaOperaciones, 2)
        subtotal = sumaOperaciones + iva + otrosImpuestos;
        total = roundTo(subtotal + ivaPercibido - ivaRetenido - retencionRenta, 2)

        return {
            sumaOperaciones: sumaOperaciones,
            iva: iva,
            subtotal: subtotal,
            ivaPercibido: ivaPercibido,
            ivaRetenido: ivaRetenido,
            retencionRenta: retencionRenta,
            otrosImpuestos: otrosImpuestos,
            resumenTributos: resumenTributos,
            total: total
        }
    }

    const roundTo = (n: number, digits: number) => {
        if (digits === undefined) {
            digits = 0;
        }

        var multiplicator = Math.pow(10, digits);
        n = parseFloat((n * multiplicator).toFixed(11));
        return Math.round(n) / multiplicator;
    }


    const modal_button_anular2 = async () => {
        let documento = formCliente?.datosSucursal?.find((sucursal: any) => sucursal?.idsucursal === formCliente?.sucursal)?.Documento?.find((doc: any) => doc?.idsucursaldocumento === formCliente?.serie)
        let serie = `${documento?.serie}-${documento?.numeroactual}`
        let ivaTotal = 0
        productos.forEach((producto) => {
            let precioUnitario = producto.conIva ? parseFloat(producto.precio)/1.13 : parseFloat(producto.precio)
            let ivaProducto = (precioUnitario * 0.13) * parseFloat(producto.cantidad)
            if(!producto.exento){
                ivaTotal += ivaProducto
            }
        })
        const anularDoc: any = {
          documento: response_Emitir.JsonFactura,
          sellorecibido: response_Emitir.Sello,
          DetallesDTE: {
            receptor: {
                numDocumento: formCliente.noDocumento,
                tipoDocumento: formCliente.tipoDocumento,
                nrc: formCliente.nrc,
                nombre: formCliente.nombre,
                telefono: formCliente.telefono,
                correo: formCliente.email,
              },
            emisor: {
                nombre: datosEmisor.nombre,
                nit: datosEmisor.nit,
                nrc: datosEmisor.nrc,
                telefono: datosEmisor.telefono,
                correo: datosEmisor.correo,
                tipoEstablecimiento: datosEmisor.tipoestablecimiento,
              },
            resumen: {
              totalIva: ivaTotal,
            },
            identificacion: {
              tipoDte: '03',
              codigoGeneracion: response_Emitir.codigoGeneracion,
              numeroControl: `DTE-03-${serie}`,
              fecEmi: convertDateFormatAnular(response_Emitir.fhProcesamiento.split(' ')[0]),
            },
          },
        }
        dispatch(anularFactura([anularDoc]))
      }

    const setTotalOriginalNota = (value: number) => {
        dispatch(handleSetTotalOriginal(value));
    }

    useEffect(() => {
        
        let precioUnitario = formProducto.conIva ? parseFloat(formProducto.precio)/1.13 : parseFloat(formProducto.precio)
        let descuento = 0
        if(formProducto.tipoDescuento === 'Porcentaje'){
            descuento = isNaN(parseFloat(formProducto.descuento)) ? 0 : (precioUnitario * parseFloat(formProducto.descuento)/100) * parseFloat(formProducto.cantidad)
        } else {
            descuento = isNaN(parseFloat(formProducto.descuento)) ? 0 : parseFloat(formProducto.descuento)
        }
        let neto = (parseFloat(formProducto.cantidad) * precioUnitario) 
        let subtotal = neto - descuento
        let iva = subtotal * 0.13
        let otrosImpuestos = processOtrosImpuestosCalculo(dteCode, formProducto, subtotal);
        if(formProducto.exento) iva = 0

        let total = subtotal + iva;
        
        dispatch(handleCalculosProducto({
            neto: isNaN(neto) ? '$0.00' : neto.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'}),
            subtotal: isNaN(subtotal) ? '$0.00' : subtotal.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'}),
            descuento: isNaN(descuento) ? '$0.00' : descuento.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'}),
            total: isNaN(total) ? '$0.00' : total.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'}),
            iva: isNaN(iva) ? '$0.00' : iva.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'}),
            otrosImpuestos: isNaN(otrosImpuestos) ? '$0.00' : otrosImpuestos.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'}),
        }))

    }, [formProducto])

    useEffect(() => {
        if(formProducto.exento){
            dispatch(handleSetFormProducto({
                ...formProducto,
                conIva: false,
            }))
        }
    }, [formProducto.exento])

    useEffect(() => {
        if(formProducto.conIva){
            dispatch(handleSetFormProducto({
                ...formProducto,
                exento: false,
            }))
        }
    }, [formProducto.conIva])

    useEffect(() => {
        if(formCliente.departamento && formCliente.departamento !== '' && clienteEncontrado === null){
            let nombreDepartamento = departamentos.find(departamento => departamento.codigo === formCliente.departamento)?.valor
            dispatch(getMunicipios(parseInt(formCliente.departamento), nombreDepartamento, true))
            dispatch(handleSetFormCliente({...formCliente, departamentoDescripcion: nombreDepartamento, municipio: ''}))
        }
    }, [formCliente.departamento])

    useEffect(() => {
        if(formCliente.tipoDocumento && formCliente.tipoDocumento !== '') validateFormCliente('noDocumento', formCliente.noDocumento)
    }, [formCliente.tipoDocumento])

    useEffect(() => {
        if(Array.isArray(formCliente.datosSucursal) && formCliente.datosSucursal.length > 0) cargarDatosIniciales()
        else if (formCliente.loadedSucursal) {
            dispatch(showMessageSucursalVacia('Nota de débito'));
            history.push('/history-invoice?reload=0');
            dispatch(handleRestarFlujoDebito());
        }
    }, [formCliente.datosSucursal, formCliente.loadedSucursal])

    useEffect(() => {
        if(formProducto.descuento){
            validateFormProducto('descuento', formProducto.descuento)
        }
    }, [formProducto])

    useEffect(() => {
        if(productoEdit.descuento){
            validateFormProductoEdit('descuento', productoEdit.descuento)
        }
    }, [productoEdit])

    return {
        cargarSucursales,
        cargarDatosIniciales,
        cargarProductosIniciales,

        buscarCliente,

        onChangeFormCliente,
        onChangeFormProducto,
        onChangeSelectCatalogoProducto,

        validateFormCliente,
        validateFormProducto,
        calculosProductos,

        setTotalOriginalNota,

        button_onClickAgregarProducto,
        button_onClickLimpiarFormProducto,
        button_onClickQuitarTodo,
        button_onBack,

        footer_onClickBack,
        footer_onClickNext,
        footer_textButtons,

        actionButton_editar,
        actionButton_eliminarProducto,

        modal_cerrarQuitarTodo,
        modal_cerrarModalEditar,
        modal_cerrarModalEliminar,
        modal_cerrarEmitir,
        modal_cerrarMasOpciones,
        modal_cerrarImprimir,
        modal_cerrarAnular,
        modal_cerrarClienteEncontrado,

        modal_button_onConfirmEdit,
        modal_button_onConfirmEliminar,
        modal_button_emitirDocumento,
        modal_button_emitirNuevo,
        modal_button_verDetalle,
        modal_button_cerrarModalEmitido,    
        modal_button_enviarCorreo,
        modal_button_cerrarEnviarCorreo,
        modal_button_onClickEnviarCorreo,
        modal_button_descargarExcel,
        modal_button_descargarImagen,
        modal_button_descargarPDF,
        modal_button_imprimir,
        modal_button_anular,
        modal_button_onConfirmAnular,
        modal_button_aceptarClienteEncontrado,
        modal_button_anular2,
        modal_button_descargarJson,

        modal_onChangeFormProductoEdit,
        modal_onChangeSelectCatalogoProductoEdit,
    }
}

const handleSetFormCliente = (form: any):ActionND => ({type: NOTA_DEBITO_TYPES.ND_SET_FORM_CLIENTE, payload: form})
const handleSetFormProducto = (form: any):ActionND => ({type: NOTA_DEBITO_TYPES.ND_SET_FORM_PRODUCTO, payload: form})
const handleErrorsFormCliente = (errors: any):ActionND => ({type: NOTA_DEBITO_TYPES.ND_HANDLE_ERRORS_CLIENTE, payload:errors})
const handleErrorsFormProducto = (errors: any):ActionND => ({type: NOTA_DEBITO_TYPES.ND_HANDLE_ERRORS_PRODUCTO, payload:errors})
const handleSetTotalOriginal = (total: number):ActionND => ({type: NOTA_DEBITO_TYPES.ND_SET_TOTAL_ORIGINAL, payload: total})
const handleSetProductosOriginal = (productos: any):ActionND => ({type: NOTA_DEBITO_TYPES.ND_SET_PRODUCTOS_ORIGINAL, payload: productos})
const handleCalculosProducto = (calculos: any):ActionND => ({type: NOTA_DEBITO_TYPES.ND_SET_CALCULOS_PRODUCTO, payload: calculos})
const handleAddProducto = (productos: any):ActionND => ({type: NOTA_DEBITO_TYPES.ND_SET_PRODUCTOS, payload: productos})
const handleRestartFormProducto = ():ActionND => ({type: NOTA_DEBITO_TYPES.ND_RESTART_FORM_PRODUCTO, payload: null})
const handleChangeView = (view: string):ActionND => ({type: NOTA_DEBITO_TYPES.ND_SET_VIEW, payload: view})
const handleActiveModalQuitarTodo = (active: boolean):ActionND => ({type: NOTA_DEBITO_TYPES.ND_ACTIVE_MODAL_QUITAR_TODO, payload: active})
const handleActiveModalEditar = (active: boolean):ActionND => ({type: NOTA_DEBITO_TYPES.ND_ACTIVE_MODAL_EDITAR_PRODUCTO, payload: active})
const handleActiveModalEliminar = (active: boolean):ActionND => ({type: NOTA_DEBITO_TYPES.ND_ACTIVE_MODAL_ELIMINAR_PRODUCTO, payload: active})
const handleActiveModalEmitir = (active: boolean):ActionND => ({type: NOTA_DEBITO_TYPES.ND_ACTIVE_MODAL_EMITIR, payload: active})
const handleActiveModalEmitido = (active: boolean):ActionND => ({type: NOTA_DEBITO_TYPES.ND_ACTIVE_MODAL_EMITIDO, payload: active})
const handleActiveModalMasOpciones = (active: boolean):ActionND => ({type: NOTA_DEBITO_TYPES.ND_ACTIVE_MODAL_MAS_OPCIONES, payload: active})
const handleActiveModalCorreo = (active: boolean):ActionND => ({type: NOTA_DEBITO_TYPES.ND_ACTIVE_MODAL_ENVIAR_CORREO, payload: active})
const handleActiveModalImprimir = (active: boolean):ActionND => ({type: NOTA_DEBITO_TYPES.ND_ACTIVE_MODAL_IMPRIMIR, payload: active})
const handleActiveModalAnular = (active: boolean):ActionND => ({type: NOTA_DEBITO_TYPES.ND_ACTIVE_MODAL_ANULAR, payload: active})
const handleActiveModalAnulado = (active: boolean):ActionND => ({type: NOTA_DEBITO_TYPES.ND_ACTIVE_MODAL_ANULADO, payload: active})
const handleSetProductoEdit = (producto: any):ActionND => ({type: NOTA_DEBITO_TYPES.ND_SET_PRODUCTO_EDIT, payload: producto})
const handleSetIndexProductoEdit = (index: any):ActionND => ({type: NOTA_DEBITO_TYPES.ND_SET_PRODUCTO_INDEX, payload: index})
const handleSetResponseEmitir = (response: any):ActionND => ({type: NOTA_DEBITO_TYPES.ND_SET_RESPONSE_EMITIR, payload: response})
const handleSetQRCode = (qr: any):ActionND => ({type: NOTA_DEBITO_TYPES.ND_SET_QR_CODE, payload: qr})
export const handleRestarFlujoDebito = ():ActionND => ({type: NOTA_DEBITO_TYPES.ND_RESTART_ALL, payload: true})

const api_getSucursales = (body: any) => http.post(ENDPOINTS.GESTION_USUARIO_POST_SUCURSALES, body, {}, KEYS.TOKEN)
const api_RecepcionDTE = (body: any) => http.post(ENDPOINTS.FACTURACION_POST_RECEPCION_DTE, body, {}, KEYS.TOKEN)
const api_buscarCliente = (body: any) => http.post(ENDPOINTS.CLIENTE_RECEPTOR_GUARDAR, body,  {}, KEYS.TOKEN)